import { Search } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { SYNC_STATUSES, UNGROUPED } from './faqOptions'

const selectClass = 'h-10 rounded-lg border border-slate-200 bg-white px-3 text-sm text-slate-700'

export default function FaqFilters({ filters, onChange, groups, sources }) {
  const { t } = useTranslation()
  const set = (name) => (event) => onChange({ ...filters, [name]: event.target.value })

  return (
    <div className="flex flex-col gap-3 lg:flex-row lg:items-center">
      <label className="relative min-w-0 flex-1">
        <Search size={16} className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
        <input
          type="search"
          value={filters.q}
          onChange={set('q')}
          maxLength={100}
          placeholder={t('faq.search.placeholder')}
          aria-label={t('faq.search.placeholder')}
          className="h-10 w-full rounded-lg border border-slate-200 bg-white pl-9 pr-3 text-sm text-slate-900"
        />
      </label>
      <select value={filters.group_id} onChange={set('group_id')} aria-label={t('faq.filters.group')} className={selectClass}>
        <option value="">{t('faq.filters.groupAll')}</option>
        {groups.map((group) => (
          <option key={group.id} value={group.id}>{group.name}</option>
        ))}
        <option value={UNGROUPED}>{t('faq.ungrouped')}</option>
      </select>
      <select value={filters.source} onChange={set('source')} aria-label={t('faq.filters.source')} className={selectClass}>
        <option value="">{t('faq.filters.sourceAll')}</option>
        {sources.map((source) => (
          <option key={source} value={source}>{t(`faq.sources.${source}`, { defaultValue: source })}</option>
        ))}
      </select>
      <select value={filters.sync_status} onChange={set('sync_status')} aria-label={t('faq.filters.status')} className={selectClass}>
        <option value="">{t('faq.filters.statusAll')}</option>
        {SYNC_STATUSES.map((status) => (
          <option key={status} value={status}>{t(`faq.syncStatus.${status}`)}</option>
        ))}
      </select>
    </div>
  )
}
